import React from 'react';
import './App.scss';
import 'animate.css';
import { Route, Router, Routes, Switch } from "react-router-dom";
import HomePage from './HomePage';
import ProjectPipe from './ProjectPipe';
import TopBar from "./components/TopBar";
import $ from "jquery";
import animateCss from './utils';
import Footer from "./components/Footer"
import AboutUs from "./AboutUs"
import UserCase from './UserCase';
import LatestNews from './LatestNews';
import NewsDetail from './NewsDetail';

class App extends React.Component {
  state = {
    isTop: true,
    isShow: true,
    top: "15rem"
  }

  componentDidMount() {
    const html = document.getElementsByTagName("html")[0],
    fontSize = window.getComputedStyle(html, null).fontSize.replace(/px/, "") * 1
    this.setState({ fontSize })
  }

  backTop() {
    window.scrollTo(0, 0)
    this.setState({ isShow: true })
    $(".hb-top-bar")[0].classList = ["hb-top-bar"]
    animateCss($(".hb-top-bar")[0], "slideInDown")
    .then(()=>{
      $(".hb-top-bar")[0].style.visibility = "visible"
    })
  }

  
  render() {
    return (
      <div className="hb-root">
        <TopBar 
          isShow={this.state.isShow} 
          setShow={(show)=>this.setState(show)} 
          setExt={(isExt)=>this.setState(isExt)} 
        />
        <Switch>
          <Route path='/' exact render={(props) => <HomePage {...props}/>}/>
          <Route path='/project-pipe' render={(props) => <ProjectPipe {...props}/>}/>
          <Route path='/user-case' render={(props) => <UserCase {...props}/>}/>
          <Route path='/latest-news' render={(props) => <LatestNews {...props}/>}/>
          <Route path='/news-detail' render={(props) => <NewsDetail {...props} setShow={(show)=>this.setState(show)} />}/>
          <Route path='/about-us' render={(props) => <AboutUs {...props}/>}/>
        </Switch>
        <div className="side-tool" style={window.location.pathname !== "/news-detail" ? { top : this.state.top, display: "flex" } : { display: "none" }}>
            <div className="line-box">
              <div className="vertical-line"></div>
            </div>
            <div style={{height: "1.4667rem"}}>
                <span>滑</span>
                <span>动</span>
            </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default App;
